// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"536f58f5","878":"72f71b88","891":"9a2cf0c6"}[chunkId] + ".chunk.js";
};